export default "__VITE_ASSET__CoYchbGw__$_?component__"